import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoaderCustom } from './core/models/translate-http-loader-custom';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { DocsComponent } from './docs/docs.component';
import { CapitalizeFirstPipe } from './core/pipes/capitalize-first.pipe';
import { APP_BASE_HREF } from '@angular/common';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoaderCustom(http, './assets/i18n/'/*, '.json'*/);
}

@NgModule({
	declarations: [
		AppComponent,
		DocsComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		CoreModule,
		SharedModule,
		// ReactiveFormsModule,
		BrowserAnimationsModule,
		HttpClientModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			}
		})
	],
	providers: [
		{
			provide: LOCALE_ID,
			useValue: 'it-IT'
		},
		CapitalizeFirstPipe,
		{provide: APP_BASE_HREF, useValue: window['base-url']}
	],
	bootstrap: [AppComponent]
})
export class AppModule {
}
